export const getAllAuthors = () => `products/authors/`

export const  getAllEditorials= () => `products/editorials/`;

export  const  getAllSliders = () => 'products/slider-elements/'

export const getProducts = () => 'products/products/list_products'